/**
 * Product feature constants used throughout the application
 */
export const PRODUCT_FEATURES = {
  /**
   * Interest Capitalised feature - used for capitalizing interest-only payments
   */
  INTEREST_CAPITALISED: 'Interest Capitalise',
  /**
   * Bridging feature - used for bridging finance products
   */
  BRIDGING: 'Bridging',
  /**
   * Reverse Mortgage feature - used for reverse mortgage products
   */
  REVERSE_MORTGAGE: 'Reverse Mortgage'
} as const;

/**
 * Product name patterns for identification
 */
export const PRODUCT_NAME_PATTERNS = {
  /**
   * Pattern to identify reverse mortgage products by name
   */
  REVERSE_MORTGAGE: 'reverse'
} as const;
